import React, { FC } from 'react';
import cx from 'classnames';
import './Button.scss';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  color?: 'base' | 'primary' | 'light' | 'gray' | 'red' | 'indigo' | 'black';
  isRadius?: boolean;
}
const Button: FC<ButtonProps> = (props) => {
  const { text, className, color = 'base', isRadius, ...res } = props;

  return (
    <button className={cx('amondz-button', className, color, { radius: isRadius })} {...res}>
      {text}
    </button>
  );
};

export default Button;
